var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 23,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.754 22.761 12.398 11.842h-.049L23.744.924H11.356L0 11.842l12.659 10.919zm5.323 0L16.423 11.842 27.778.924h12.377L28.761 11.842h.049l11.356 10.919zm16.59 0L33.01 11.842 44.367.924h12.377L45.35 11.842h.049l11.356 10.919z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorLeft);
export default __webpack_public_path__ + "static/media/vectorLeft.703e10ec3ce2b78d590f1652a0ee5618.svg";
export { ForwardRef as ReactComponent };